import $ from 'jquery';

export default function HelpAreaChat() {
    this.$container = $('.js-helparea-container');
    this.template = $('.js-helparea-template').html();
    this.chatTitleTemplate = $('.js-helparea-title-template').html();

    this.snapEngage = window.SnapEngage;
    this.snapEngageChat = window.SnapEngageChat;

    this.setSettingsToChat();
    this.bindEvents();

    if (!this.snapEngage.isChatInProgess()) {
        this.showChatButton();
    }
}

$.extend(HelpAreaChat.prototype, {
    bindEvents: function () {
        this.snapEngage.setCallback('Open', this.onChatOpen.bind(this));
        this.snapEngage.setCallback('OpenProactive', this.onChatOpenProactive.bind(this));
        this.snapEngage.setCallback('Close', this.onChatClose.bind(this));
        this.snapEngage.setCallback('MessageSubmit', this.onMessageSubmit.bind(this));
        this.snapEngage.setCallback('StartChat', this.onStartChat.bind(this));
        this.snapEngage.setCallback('ChatMessageSent', this.onChatMessageSent.bind(this));
        this.snapEngage.setCallback('ChatMessageReceived', this.onChatMessageReceived.bind(this));
        this.snapEngage.setCallback('StartCallme', this.onStartCall.bind(this));
    },
    setSettingsToChat: function () {
        this.snapEngage.allowProactiveChat(true);
        this.snapEngage.allowChatSound(true);
        this.snapEngageChat.setTitle(this.chatTitleTemplate);
    },

    showChatButton: function () {
        this.$container.html(this.template);
        this.$container.find('.js-helparea-chat').on('click', this.snapEngage.startLink);
    },
    hideChatButton: function () {
        this.$container.empty();
    },

    remove: function () {
        this.showChatButton();
    },

    onChatOpen: function () {
        this.hideChatButton();
        this.pushToDataLayer({
            eventCategory: 'Chat',
            eventAction: 'ChatOpen',
            event: 'ChatMessageOpen'
        });
    },
    onChatOpenProactive: function () {
        this.pushToDataLayer({
            eventCategory: 'Chat',
            eventAction: 'ChatProactive',
            event: 'ChatProactive'
        });
    },
    onChatClose: function (elementClosed) {
        this.showChatButton();
        this.pushToDataLayer({
            eventCategory: 'Chat',
            eventAction: 'ChatClose',
            eventLabel: elementClosed,
            event: 'CloseChat'
        });
    },
    onMessageSubmit: function () {
        this.pushToDataLayer({
            eventCategory: 'Chat',
            eventAction: 'ChatMessageSubmit',
            event: 'ChatMessageSubmit'
        });
    },
    onStartChat: function (email, msg, type) {
        this.pushToDataLayer({
            eventCategory: 'Chat',
            eventAction: 'ChatStart',
            eventLabel: type,
            event: 'ChatStart'
        });
    },
    onChatMessageSent: function () {
        this.pushToDataLayer({
            eventCategory: 'Chat',
            eventAction: 'ChatMessageSent',
            event: 'ChatMessageSent'
        });
    },
    onChatMessageReceived: function () {
        this.pushToDataLayer({
            eventCategory: 'Chat',
            eventAction: 'ChatMessageReceived',
            event: 'ChatMessageReceived'
        });
    },
    onStartCall: function () {
        this.pushToDataLayer({
            eventCategory: 'Chat',
            eventAction: 'ChatCallme',
            event: 'ChatCallme'
        });
    },
    pushToDataLayer: function (event) {
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push(event);
        }
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/helparea/chat.js
 **/